import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import '../Style/main.css'
import '../Style/responsive.css'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import illustrateImage from '../Images/Illustrator.svg'
import bg1 from '../Images/bg1.png'
import bg2 from '../Images/bg2.png'
import logo from '../Images/logo.png'
import { calculatePrice } from '../Http/ApiCalls'
import BounceLoader from 'react-spinners/BounceLoader'

const Home = () => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [values, setValues] = useState({
        userName: '',
        city: ''
    })

    const override = {
        display: 'block',
        margin: ' 400px auto',
        borderColor: 'red'
    }

    const { userName, city } = values

    const handleChange = (item) => (event) => {
        const value = event.target.value
        setValues({ ...values, [item]: value })
    }

    const submitHandler = (event) => {
        event.preventDefault()
        setLoading(true)
        calculatePrice(userName, city)
            .then((user) => {
                setLoading(false)
                navigate('/submit', {
                    state: {
                        userData: user.data
                    }
                })
            })
            .catch((err) => {
                setLoading(false)
                toast(err.data.message, {
                    position: 'top-right',
                    autoClose: 3000,
                    type: 'error',
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'light'
                })
            })
    }

    return (
        <div className="surveyPage container-fluid">
            {loading ? (
                <>
                    <BounceLoader
                        color={'#120E43'}
                        loading={true}
                        size={60}
                        cssOverride={override}
                    />
                </>
            ) : (
                <>
                    <div className="row">
                        <div className="col-12 col-5 col-lg-5">
                            <div className="leftSide">
                                <div className="header">
                                    <a href="https://influencercommunityofindia.com/">
                                        <img
                                            src={logo}
                                            alt="bglogo"
                                            id="icilogo"
                                            className="img-fluid"
                                        />
                                    </a>
                                </div>

                                <img
                                    src={bg2}
                                    alt="background"
                                    id="bgImage2"
                                    className="img-fluid"
                                />
                                <img
                                    src={illustrateImage}
                                    alt="Illustateimage"
                                    id="mainImage"
                                    className="img-fluid"
                                />
                                <img
                                    src={bg1}
                                    alt=""
                                    id="bgImage1"
                                    className="img-fluid"
                                />
                            </div>
                        </div>
                        <div className="col-7 col-lg-7 col-12">
                            <div className="rightSide">
                                <h5>Hey Creators!</h5>
                                <p>
                                    Get Your Certified Pricing, derived by a benchmark algorithm that takes all parameters of impact in the
                                    calculation. Backed by smart tech, the algorithm is tested with thousands of influencers and various brands.
                                </p>
                                <form onSubmit={submitHandler}>
                                    <label htmlFor="userName">Enter your (Business/Creator) Instagram username or profile link</label>
                                    <input
                                        type="text"
                                        id="userName"
                                        onChange={handleChange('userName')}
                                        required
                                        placeholder="Instagram Username"
                                    />
                                    <label htmlFor="userCity">Your city name here</label>
                                    <input
                                        type="text"
                                        id="userCity"
                                        onChange={handleChange('city')}
                                        required
                                        placeholder="City Name"
                                    />
                                    <br />
                                    <button type="submit">Submit</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </>
            )}

            <ToastContainer />
        </div>
    )
}

export default Home
